import { useUserStore } from '@/stores/store.user';
import { api } from '@/api/axiosConfig';

type Credentials = {
  "username": string,
  "password": string
}

export default{
    name:'userApi',
    async login(username:string, password: string) {
      
      const credentials: Credentials = {username: username, password: password};
      const response =  await api.post('/v2/user/login', credentials);    
      return response.data;
    },
    async logout(){
      const userStore = useUserStore();
      const userToken = await userStore.getToken;
      await api.post('/oauth2/revoke', { token: userToken });
    },
    async updatePassword(id:number,password: string){
      return api.put('/v2/user/password',{params:{userid: id, password:password}}).then((response) => {
          return response.data;
      });
    },
    async validateFirstAccess(id:number,data:object){
      return api.put('/v2/user/validate-first-access',{params:{userid: id, data}}).then((response) => {
        return response.data;
      });
    },
    async recoveryPassword(dniOrCif:string){
      return api.post('/v2/user/recovery-password',{params:{user:dniOrCif}}).then((response) => {
        return response.data;
      });
    },
    async setTokenDevice(userid:number, token:string){
      return api.post('/v2/user/set-token-device',{params:{userid, token}}).then((response) => {
        return response.data;
      });
    }
    
}
